import { jsx as _jsx } from "react/jsx-runtime";
import { PillLink } from '@yonderland/andes-react';
export const ListerQuickLinkItem = ({ quickLink }) => (_jsx(PillLink, { theme: "neutral", variant: "tertiary", size: "sm", title: quickLink.linkName, href: `${quickLink.linkPath}${quickLink.queryStringParams || ''}`, children: quickLink.linkName }));
